<ion-row class="component-padding-sm">
  <ion-col size="12" class="ion-text-center">
    <h3 class="stripe-title dark">Nucamp offers affordable tuition financing with the only <b class="highlightPurple"><a routerLink="/financing" style="border-bottom: 1px dashed;">Fair Student Agreement (FSA)</a></b></h3>
    <!-- <h4 class="stripe-subtitle">
      As low as <b class="highlightPink">$0 for 12 months.</b>
      <br>Then as low as <b class="highlightPink">$186 per month</b> for 36 months.
    </h4> -->
    <h4 class="stripe-subtitle">
      <span class="dark">Other bootcamps offer Income Sharing Agreements (ISA), 
        where students <b class="highlightPurple">give up 15% of their future gross salary</b> for years, in exchange for a 4-month course. 
        This results in paying well over the original tuition cost.</span>
    </h4>
    <a class="stripe-subtitle rowpadding hyperlink" routerDirection="root" routerLink="/blog/are-income-share-agreements-scams">
      "Critics say Income Share Agreements (ISAs) are yet another instrument of student debt, prone to deceptive
      marketing and predatory lending terms." - <b class="dark">Tony Wan, Edsurge.com.</b>
    </a>
  </ion-col>
</ion-row>

<ion-row class="list">
  <ion-col class="listLeftCol" size="12" size-sm="12" size-md="6" size-lg="6">
    <ion-row style="margin-bottom: 15px;">
      <ion-col class="ion-text-center" style="height: 6rem">
        <img width="200px" height="auto" src="/assets/imgs/communities/nucamp-logo-full-lockup-color-vector.svg" alt="Nucamp Logo">
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center component-padding-sm">
        <h5>Fair Student Agreement (FSA)*</h5>
      </ion-col>
    </ion-row>

    <ion-row style="margin-top: 10px" class="component-padding-sm">
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck" style="color: #0096dc"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Affordable tuition from $458-$2,905 helps you gain technical skills without committing to risky loans.</p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck" style="color: #0096dc"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Pay <b class="highlightBlue">as low as $0 for 12 months</b> (for the Complete Software Engineering Bootcamp Path) until you graduate, so you can focus on developing your skills.</p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck" style="color: #0096dc"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Terms can be 12, 18, 24, 36 or 48 months with payments as low as <b class="highlightBlue">$99/month</b>
          so you can reasonably manage them even before you land a new job.</p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck" style="color: #0096dc"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">~70% graduation rate. Nucamp refunds you according to state laws if you don't.</p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck" style="color: #0096dc"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Get an extra buffer of time to find the job that's best for you.</p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck" style="color: #0096dc"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Legal and regulated nationwide.</p>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">*Loan terms displayed are effective as of February 2025. To see full repayment examples, visit the Ascend or Climb Credit websites.</p>
      </ion-col>
    </ion-row>
  </ion-col>


  <ion-col class="listRightCol" size="12" size-sm="12" size-md="6" size-lg="6">
    <ion-row style="margin-bottom: 15px;">
      <ion-col class="ion-text-center" style="line-height: 5.2rem">
        <!-- <img width="200px" height="auto" src="/assets/imgs/communities/graphic-traditional-bootcamps.svg"> -->
        <p class="traditionalBc">Traditional Bootcamps</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center component-padding-sm">
        <h5>Income Sharing Agreement (ISA)</h5>
      </ion-col>
    </ion-row>

    <ion-row style="margin-top: 10px" class="component-padding-sm">
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon error" [icon]="faExclamationTriangle" style="color: #ff0000"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Expensive, can cost up to $15,000 $20,000 and even $85,000 per bootcamp.</p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon error" [icon]="faExclamationTriangle" style="color: #ff0000"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Many require deposits, some of which are more expensive than our entire Full Stack Bootcamp.</p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon error" [icon]="faExclamationTriangle" style="color: #ff0000"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">High risks that will take 10%-17% of your gross income for years once you get a job.</p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon error" [icon]="faExclamationTriangle" style="color: #ff0000"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Some require you to take the first job offer you receive, even if you don't like it or it's not in tech.</p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon error" [icon]="faExclamationTriangle" style="color: #ff0000"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Undisclosed chance to graduate. You owe money if you don't.</p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon error" [icon]="faExclamationTriangle" style="color: #ff0000"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">After the grace period, you still have to pay back the tuition even if you never get a job.
        </p>
      </ion-col>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon error" [icon]="faExclamationTriangle" style="color: #ff0000"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Unregulated, and illegal in certain states.</p>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>